import * as React from "react";

import { ICalendarPage, IServer, ITreeViewNode } from "../../classes/state";
import { IText, IText_SelectEvents } from "../../classes/text";

export class SelectEventsUtilities {

    public createServerTreeNodes = (servers: IServer[], recordsPerPage: number, currentPageNumber: number, text: IText_SelectEvents): ITreeViewNode[] => {
        const treeViewNodes: ITreeViewNode[] = [];

        let serverNumber = 1;
        for (const server of servers) {
            const treeNode: ITreeViewNode = {
                children: this.createChildTreeNodes(server.serverId, server.calendarPages, "server", text),
                className: this.getServerClassName(serverNumber, recordsPerPage, currentPageNumber),
                disabled: true,
                icon: <i className="fa fa-server" />,
                label: server.name,
                nodeType: "server",
                pageNumber: this.getPageNumber(serverNumber, recordsPerPage),
                value: server.serverId.toString(),
            };
            treeViewNodes.push(treeNode);
            serverNumber++;
        }

        return treeViewNodes;
    }

    public createChildTreeNodes = (serverId: number, calendarPages: ICalendarPage[], parentNodeType: string, text: IText_SelectEvents): ITreeViewNode[] => {
        let nodes: ITreeViewNode[] = [];

        if (calendarPages && calendarPages.length > 0) {
            nodes = this.convertCalendarPagesToTreeViewNodes(serverId, calendarPages, parentNodeType, text);
        } else {
            if (parentNodeType === "server") {
                if (calendarPages && calendarPages.length <= 0) {
                    nodes.push(this.createNoCalendarsTreeViewNode(serverId, text.thisServerHasNoCalendars));
                } else {
                    nodes.push(this.createDefaultLoadingTreeViewNode(serverId, text.loading));
                }
            }
        }

        return nodes;
    }

    public convertCalendarPagesToTreeViewNodes = (serverId: number, calendarPages: ICalendarPage[], parentNodeType: string, text: IText_SelectEvents): ITreeViewNode[] => {
        const nodes: ITreeViewNode[] = [];

        if (calendarPages && calendarPages.length > 0) {
            for (const calendarPage of calendarPages) {
                const node: ITreeViewNode = {
                    children: this.convertCalendarPagesToTreeViewNodes(serverId, calendarPage.childNodes, calendarPage.objectType, text),
                    className: this.getNodeClassName(calendarPage.objectType, calendarPage.calendarId),
                    disabled: this.getNodeDisabled(calendarPage.objectType),
                    icon: this.getNodeIcon(calendarPage.objectType, calendarPage.calendarId),
                    label: calendarPage.name,
                    nodeType: this.getNodeType(calendarPage.objectType, calendarPage.calendarId),
                    value: calendarPage.itemId.toString(),
                };
                nodes.push(node);
            }
        } else {
            if (parentNodeType === "server") {
                nodes.push(this.createNoCalendarsTreeViewNode(serverId, text.thisServerHasNoCalendars));
            }
        }

        return nodes;
    }

    public getCheckedNodeCalendarIdsForServers = (servers: IServer[], checkedNodeItemIds: string[]): string[] => {
        let checkedNodeCalendarIds: string[] = [];

        for (const server of servers) {
            checkedNodeCalendarIds = this.getCheckedNodeCalendarIdsForCalendarPages(server.calendarPages, checkedNodeItemIds, checkedNodeCalendarIds);
        }

        return checkedNodeCalendarIds;
    }

    public getCheckedNodeCalendarIdsForCalendarPages = (calendarPages: ICalendarPage[], checkedNodeItemIds: string[], checkedNodeCalendarIds: string[]): string[] => {

        if (calendarPages !== null) {
            for (const calendarPage of calendarPages) {
                if (calendarPage.calendarId.toString() !== "0") {
                    if (checkedNodeItemIds.indexOf(calendarPage.itemId) >= 0) {
                        checkedNodeCalendarIds.push(calendarPage.calendarId);
                    }
                }
                checkedNodeCalendarIds = this.getCheckedNodeCalendarIdsForCalendarPages(calendarPage.childNodes, checkedNodeItemIds, checkedNodeCalendarIds);
            }
        }

        return checkedNodeCalendarIds;
    }

    private getServerClassName(serverNumber: number, recordsPerPage: number, currentPageNumber: number): string {
        if (Math.ceil(serverNumber / recordsPerPage) === currentPageNumber) {
            return "treeNode_Server";
        } else {
            return "treeNode_NoDisplay";
        }
    }

    private getPageNumber(serverNumber: number, recordsPerPage: number): number {
        return Math.ceil(serverNumber / recordsPerPage);
    }

    private createDefaultLoadingTreeViewNode = (serverId: number, loadingText: string): ITreeViewNode => {
        const loadingNode: ITreeViewNode = {
            className: "treeNode_Loading",
            disabled: true,
            icon: <i className="fa fa-spinner" />,
            label: loadingText,
            nodeType: "loading",
            value: "LoadingServerId" + serverId.toString(),
        };
        return loadingNode;
    }

    private createNoCalendarsTreeViewNode(serverId: number, noCalendarsText: string): ITreeViewNode {
        const noCalendarsNode: ITreeViewNode = {
            className: "treeNode_NoCalendars",
            disabled: true,
            icon: <i className="fa fa-calendar-times-o" />,
            label: noCalendarsText,
            nodeType: "noCalendars",
            value: "NoSitesId" + serverId.toString(),
        };
        return noCalendarsNode;
    }

    private getNodeIcon(objectType: string, calendarId: string): JSX.Element {
        let icon: JSX.Element = null;
        if (objectType === "ptl_portal") { icon = <i className="fa fa-home" />; }
        if (objectType === "ptl_page") {
            if (calendarId.toString() === "0") {
                icon = <i className="fa fa-file-text-o" />;
            } else {
                icon = <i className="fa fa-calendar" />;
            }
        }
        return icon;
    }

    private getNodeClassName(objectType: string, calendarId: string): string {
        let className: string = "";
        if (objectType === "ptl_portal") { className = "treeNode_Site"; }
        if (objectType === "ptl_page") {
            if (calendarId.toString() === "0") {
                className = "treeNode_Page";
            } else {
                className = "treeNode_Calendar";
            }
        }
        return className;
    }

    private getNodeDisabled(objectType: string): boolean {
        if (objectType === "ptl_portal") { return true; }
        return false;
    }

    private getNodeType(objectType: string, calendarId: string): string {
        let nodeType: string = "";
        if (objectType === "ptl_portal") { nodeType = "site"; }
        if (objectType === "ptl_page") {
            if (calendarId.toString() === "0") {
                nodeType = "page";
            } else {
                nodeType = "calendar";
            }
        }
        return nodeType;
    }

}
